import React, { useState, useEffect } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, Modal, Platform } from 'react-native';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebaseConfig';
import { setDoc, doc } from 'firebase/firestore';
import { MaterialIcons } from '@expo/vector-icons';
import * as Notifications from 'expo-notifications';
import Constants from 'expo-constants';

const RegisterMotoboy = ({ navigation }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [cpf, setCpf] = useState('');
  const [phone, setPhone] = useState('');
  const [plate, setPlate] = useState('');
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    navigation.setOptions({ headerShown: false });
  }, [navigation]);

  const showAlert = (title, message) => {
    if (Platform.OS === 'web') {
      alert(`${title}: ${message}`);
    } else {
      alert(message);
    }
  };
  
  const handleRegister = async () => {
    if (!email || !password || !name || !cpf || !phone || !plate) {
      showAlert('Erro', 'Por favor, preencha todos os campos.');
      return;
    }

    setLoading(true);

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const motoboyData = {
        tipo: 'motoboy',
        motoboyName: name,
        motoboyCPF: cpf,
        motoboyPhone: phone,
        motoboyPlate: plate,
        ativo: false,
        expoPushToken: "", 
        email: email,
        password: password,
      };

      await setDoc(doc(db, 'usuarios', user.uid), motoboyData);

      setShowSuccessModal(true);

      setTimeout(() => {
        setShowSuccessModal(false);
        navigation.reset({
          index: 0,
          routes: [{ name: 'LoginScreen' }],
        });
      }, 1000);
    } catch (error) {
      showAlert('Erro ao registrar motoboy', error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
        <MaterialIcons name="arrow-back" size={24} color="#FFF" />
      </TouchableOpacity>
      <Text style={styles.title}>Registrar Motoboy</Text>

      <View style={styles.inputContainer}>
        <MaterialIcons name="email" size={24} color="#000" />
        <TextInput
          placeholder="Email"
          value={email}
          onChangeText={(text) => setEmail(text.replace(/\s/g, ''))} // Remove espaços enquanto o usuário digita
          style={styles.input}
          keyboardType="email-address"
          autoCapitalize="none"
        />
      </View>

      <View style={styles.inputContainer}>
        <MaterialIcons name="lock" size={24} color="#000" />
        <TextInput
          placeholder="Senha"
          value={password}
          onChangeText={(text) => setPassword(text.replace(/\s/g, ''))} // Remove espaços enquanto o usuário digita
          secureTextEntry
          style={styles.input}
        />
      </View>

      <View style={styles.inputContainer}>
        <MaterialIcons name="person" size={24} color="#000" />
        <TextInput
          placeholder="Nome Completo"
          value={name}
          onChangeText={setName}
          style={styles.input}
        />
      </View>

      <View style={styles.inputContainer}>
        <MaterialIcons name="credit-card" size={24} color="#000" />
        <TextInput
          placeholder="CPF"
          value={cpf}
          onChangeText={setCpf}
          style={styles.input}
          keyboardType="numeric"
        />
      </View>

      <View style={styles.inputContainer}>
        <MaterialIcons name="phone" size={24} color="#000" />
        <TextInput
          placeholder="Telefone"
          value={phone}
          onChangeText={setPhone}
          style={styles.input}
          keyboardType="phone-pad"
        />
      </View>

      <View style={styles.inputContainer}>
        <MaterialIcons name="motorcycle" size={24} color="#000" />
        <TextInput
          placeholder="Placa da Moto"
          value={plate}
          onChangeText={(text) => {
            // Permite apenas letras maiúsculas e números, limitando a 7 caracteres
            const formattedText = text.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 7);
            setPlate(formattedText);
          }}
          style={styles.input}
        />
      </View>

      {loading ? (
        <TouchableOpacity style={[styles.registerButton, { backgroundColor: '#888' }]} disabled>
          <Text style={styles.registerButtonText}>Registrando...</Text>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity style={styles.registerButton} onPress={handleRegister}>
          <Text style={styles.registerButtonText}>Registrar</Text>
        </TouchableOpacity>
      )}

      <Modal
        visible={showSuccessModal}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setShowSuccessModal(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <MaterialIcons name="check-circle" size={50} color="#4CAF50" />
            <Text style={styles.modalText}>Motoboy registrado com sucesso!</Text>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    padding: 16,
    backgroundColor: '#2c5364', // Fundo escuro
  },
  backButton: {
    position: 'absolute',
    top: 70,
    left: 30,
    zIndex: 10,
    backgroundColor: '#203a43', // Fundo consistente
    padding: 10,
    borderRadius: 50,
    shadowColor: '#000',
    shadowOpacity: 0.3,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 24,
    textAlign: 'center',
    color: '#FFF', // Texto branco
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    borderColor: '#00FF9D', // Borda verde neon
    borderWidth: 1,
    borderRadius: 10,
    paddingHorizontal: 10,
    backgroundColor: '#203a43', // Fundo do campo escuro
  },
  input: {
    flex: 1,
    height: 50,
    color: '#FFF', // Texto branco
    fontSize: 16,
    paddingLeft: 10,
    backgroundColor: '#2c5364', // Fundo consistente
  },
  registerButton: {
    backgroundColor: '#00FF9D', // Botão verde neon
    padding: 15,
    borderRadius: 10,
    alignItems: 'center',
    marginTop: 20,
    borderWidth: 1,
    borderColor: '#FFF', // Borda branca
  },
  registerButtonText: {
    color: '#203a43', // Texto escuro para contraste
    fontSize: 16,
    fontWeight: 'bold',
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.8)', // Fundo escuro translúcido
  },
  modalContent: {
    backgroundColor: '#203a43', // Fundo escuro
    padding: 20,
    borderRadius: 10,
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#00FF9D', // Borda neon
    shadowColor: '#000',
    shadowOpacity: 0.5,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
  },
  modalText: {
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 10,
    color: '#00FF9D', // Texto verde neon
  },
});

export default RegisterMotoboy;
